import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { EmptyState } from "@/components/common/EmptyState";
import { SurfaceCard } from "@/components/common/Cards";
import { StatusBadge } from "@/components/common/StatusBadge";
import { initials } from "@/lib/format";
import { Avatar } from "@/components/common/Avatar";
import { UsersRound, Mail } from "lucide-react";

export default function Team() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/team").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div>
      <PageHeader title="Team" subtitle="Your clinical and practice team" breadcrumb={["Practice", "Team"]} />
      {items && items.length === 0 ? (
        <EmptyState icon={UsersRound} title="No team members" description="Invite your clinical and administrative team." testId="team-empty" />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {(items || []).map((m) => (
            <SurfaceCard key={m.id} className="p-5">
              <div className="flex items-center gap-3">
                <Avatar src={m.avatar} name={m.name} size={48} />
                <div className="min-w-0 flex-1"><div className="text-sm font-bold text-[#101516] dark:text-white truncate">{m.name}</div><div className="text-xs text-[#8B9698]">{m.role}</div></div>
                <StatusBadge status={m.status} />
              </div>
              <div className="mt-3 flex items-center gap-1.5 text-xs text-[#8B9698] border-t border-[#E2E8F0]/60 dark:border-[#223139]/60 pt-3"><Mail className="h-3.5 w-3.5" />{m.email}</div>
            </SurfaceCard>
          ))}
        </div>
      )}
    </div>
  );
}
